import { Box } from 'bonfire-kindling';
import { useTranslation } from 'react-i18next';
import loadingIcon from 'assets/puff.svg';
import SettingsSideNav from '../SettingsSideNav/SettingsSideNav';

const SettingsContainer = ({ children, index, isLoading, ...rest }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ height: '100%', p: 5 }} {...rest}>
      {isLoading ? (
        <Box marginTop="10%" marginLeft="50%">
          <img alt={t('components.loading_icon')} src={loadingIcon} height="44" width="44" />
        </Box>
      ) : (
        <>
          <SettingsSideNav />
          <Box
            sx={{
              width: theme => ({ sm: `calc(100% - ${theme.widths.sideNav}px)` }),
              ml: theme => ({ sm: `${theme.widths.sideNav}px` }),
            }}
          >
            {children}
          </Box>
        </>
      )}
    </Box>
  );
};

export default SettingsContainer;
